import React from "react";
import Header from "../../components/Customer/Header";
import Footer from "../../components/Customer/Footer";
import FeedbackSection from "../../components/Customer/FeedbackSection";

function FeedbackPage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-100 via-white to-amber-100 font-sans">
      <Header />
      <main className="max-w-4xl mx-auto px-6 py-10">
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center mb-6">
            <img src="/images/araliya-tours-logo.png" alt="Araliya Tours" className="h-36 w-auto" />
          </div>
          <h1 className="text-4xl font-bold text-gray-900 font-poppins mb-4">Share Your Experience</h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Your feedback helps us improve and means the world to our team. We'd love to hear how your trip went.
          </p>
        </div>
        <FeedbackSection />
      </main>
      <Footer />
    </div>
  );
}

export default FeedbackPage;
